import type { TipPopup } from '../types';

interface PulseTipPopupProps {
  popup: TipPopup;
}

/**
 * Ephemeral floating dollar sign that pops up when a tip is received.
 * Scales in, floats upward, and fades out — pure CSS animation, fire-and-forget.
 */
export function PulseTipPopup({ popup }: PulseTipPopupProps) {
  const formattedAmount = formatCurrency(popup.amount, popup.currency);

  return (
    <div className="pulse-tip-popup pointer-events-none absolute inset-0 flex items-center justify-center">
      <div className="pulse-anim-tip-float flex flex-col items-center">
        <span className="text-2xl font-black text-emerald-400 drop-shadow-[0_0_8px_rgba(52,211,153,0.8)]">
          {formattedAmount}
        </span>
        {popup.tipperUsername && (
          <span className="text-[9px] text-white/60">
            from @{popup.tipperUsername}
          </span>
        )}
      </div>
    </div>
  );
}

function formatCurrency(amount: number, currency: string): string {
  const symbol = CURRENCY_SYMBOLS[currency.toUpperCase()] ?? '$';
  return `${symbol}${amount.toFixed(amount % 1 === 0 ? 0 : 2)}`;
}

const CURRENCY_SYMBOLS: Record<string, string> = {
  AUD: '$',
  USD: '$',
  GBP: '£',
  EUR: '€',
  CAD: 'C$',
  NZD: 'NZ$',
  JPY: '¥',
};
